import React from 'react';
import { Route } from 'react-router-dom';
import { Dashboard } from './component/dashboard/Dashboard'

export default [
  <Route exact key="dashboard" path="/dashboard" component={Dashboard} />,
];